import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.partners
)

export const selectPartners = createSelector(
    baseSelector,
    (state) => state.partners
)
export const selectPartnersLoading = createSelector(
    baseSelector,
    (state) => state.isPartnersLoading
)
export const selectPartnersError = createSelector(
    baseSelector,
    (state) => state.partnersError
)
export const selectStores = createSelector(
    baseSelector,
    (state) => state.stores
)
export const selectStoresLoading = createSelector(
    baseSelector,
    (state) => state.isStoresLoading
)
export const selectStoresError = createSelector(
    baseSelector,
    (state) => state.storesError
)
export const selectOEMGroups = createSelector(
    baseSelector,
    (state) => state.OEMGroups
)
export const selectOEMGroupsLoading = createSelector(
    baseSelector,
    (state) => state.isOEMGroupsLoading
)